import "./Footer.css";
import { Link } from "react-router-dom";
import VisitorCounter  from "../components/VisitorCounter";

export const Footer = () => {
  const branchLoc =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d365229.0343616369!2d82.53169522310487!3d24.41520243564483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398ef9c5a7931aa9%3A0x22e797ee960720a5!2sSonbhadra%2C%20Uttar%20Pradesh%2C%20India!5e0!3m2!1sen!2sus!4v1690624318715!5m2!1sen!2sus";
  return (
    <>
      <div className="footer">
        <div className="fbox">
          <div className="aboutus">
            <h2>
              <span id="fdiff">A</span>bout us
            </h2>
            <p>
            Discover the hidden gem of India. Sonbhadra Tourism offers breathtaking landscapes, rich history, and thrilling adventures. Just Contact us, rest will take care for you.
            </p>
          </div>
          <div className="branch">
            <h2>
              <span id="fdiff">B</span>ranch Location
            </h2>
            <iframe
              src={branchLoc}
              style={{ border: 0 }}
              id="map"
              allowFullScreen=""
              loading="lazy"
              title="Brach Location"
            ></iframe>
          </div>
          <div className="quicklinks">
            <h2>
              <span id="fdiff">Q</span>uick Links
            </h2>
            <ul>
            <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/aboutus">About Us</Link>
              </li>
              <li>
                <Link to="/book">Book</Link>
              </li>
              <li>
                <Link to="/locations">Locations</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <li>
              <a href="https://sonbhadra.nic.in/" target="_blank" rel="noopener noreferrer"> District Gov. Site
          </a>  
              </li>
            </ul>
          </div>
          <div className="follow">
            <h2>
              <span id="fdiff">F</span>ollow us
            </h2>
            <ul>
              <li>
              <a href="https://www.instagram.com/sonebhadratourism" target="_blank" rel="noopener noreferrer" id="instagram">
            
                  <i className="fab fa-instagram"></i>
              
                </a>
              </li>
              <li>
              <a href="https://www.facebook.com/sonbhadratourism64/" target="_blank" rel="noopener noreferrer" id="facebook">
                  <i className="fab fa-facebook"></i>
                </a>
              </li>
              <li>
              <a href="https://x.com/sonbhadratour" target="_blank" rel="noopener noreferrer" id="twitter">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li> 
              <a href="https://www.youtube.com/@sonebhadratourism" target="_blank" rel="noopener noreferrer" id="youtube">
                  <i className="fab fa-youtube"></i>
                </a>

              </li>
              <li>
              <a href="https://www.linkedin.com/company/sonbhadratourism/" target="_blank" rel="noopener noreferrer" id="linkedin">
                  <i className="fab fa-linkedin"></i>
                </a>
              </li>

            </ul>
          </div>
        </div>
        <hr />
        <div className="copy">
          <h2>
            Copyright &copy; <span id="fdiff">S</span>onbhadra Tourism 2023-24 | All
            Rights Reserved
          </h2>
          
        </div>
        <VisitorCounter />  {/* Add visitor count here */}
      </div>
    </>
  );
};
